// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoLandingDownloadLinks')

function IntoLandingDownloadLinks(props) {
  const { isAndroid, isDesktop, isIos, iosDeeplinkHref, showSMSModal, trackAppDownload } = props
  const handleDownloadClick = React.useCallback(
    event => {
      const { provider } = event.currentTarget.dataset
      trackAppDownload(provider)
      if (isDesktop && provider === 'ios') {
        event.preventDefault()
        showSMSModal()
        return
      }
    },
    [ isDesktop, showSMSModal, trackAppDownload ]
  )
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      (isIos || isDesktop) && tag(CapsuleButton, {
        className: bem.element('download', 'apple'),
        'data-provider': 'ios',
        href: iosDeeplinkHref,
        onClick: handleDownloadClick
      },
        tag(Icon, { id: 'apple' }),
        tag('div', {
          className: bem.element('link-text')
        },
          'Get the Mix app'
        )
      ),
      (isAndroid || isDesktop) && tag(CapsuleButton, {
        className: bem.element('download', 'waitlist'),
        'data-provider': 'android',
        href: 'https://forms.gle/3hmi14R6xX5E8mtVA',
        onClick: handleDownloadClick
      },
        tag(Icon, { id: 'android' }),
        tag('div', {
          className: bem.element('link-text')
        },
          'Join the waitlist'
        )
      )
    )
  )
}

module.exports = IntoLandingDownloadLinks
